import { render } from "./DomaineActivite.vue?vue&type=template&id=04f35f5e"
import script from "./DomaineActivite.vue?vue&type=script&lang=js"
export * from "./DomaineActivite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__